import React from 'react';
import { PhoneOTPScreen } from '@/modules';

export default function PhoneOTPRoute() {
    return <PhoneOTPScreen />;
}